import React from 'react';
import PropTypes, { object } from 'prop-types';
import cn from 'classnames';

import { Text } from '../../../Elements';

import classes from './SelectOption.module.scss';

const SelectOption = ({
  capitalize = true,
  checkRenderKey,
  data,
  isMulti,
  isSelected,
  uppercase = false
}) => {
  const styleOption = data.className;
  return (
    <div
      className={cn(
        classes.optionWrap,
        !isMulti && isSelected && classes.optionWrap_select
      )}
    >
      {isMulti && (
        <div
          className={cn(
            classes.checkBox,
            typeof data.label === 'string'
              ? isSelected && classes.checkBox_selected
              : isSelected
              ? classes.checkBox_selected
              : classes.checkBox_hide
          )}
        >
          {isSelected && <div className={classes.arrow} />}
        </div>
      )}

      <Text
        className={cn(
          styleOption ? styleOption : classes.label,
          !isMulti && classes.label_noMulti,
          capitalize && classes.label_capitalize,
          uppercase && classes.label_uppercase
        )}
      >
        {isSelected && typeof data.label !== 'string'
          ? data[checkRenderKey]
          : data.label}
      </Text>
    </div>
  );
};

SelectOption.propTypes = {
  capitalize: PropTypes.bool,
  checkRenderKey: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.arrayOf(object), PropTypes.object])
    .isRequired,
  isMulti: PropTypes.bool,
  isSelected: PropTypes.bool,
  uppercase: PropTypes.bool
};

export default SelectOption;
